export const SAML_APPLICATION = "application using SAML";
export const SBA_TITLE_ADD = "Add " + SAML_APPLICATION;
export const SBA_TITLE_EDIT = "Edit " + SAML_APPLICATION;
export const SBA_SUBTITLE = "Configure a SAML-based application for single sign-on.";
export const SBA_APPNAME_LABEL = "Application profile name";
export const SBA_APPNAME_USER_FRIENDLY_LABEL = "Application user-friendly name";
export const SBA_METADATA_REQUIRES = "Imprivata requires SAML metadata configuration information from the application.";
export const SBA_METADATA_REQUIRED_SP = "Identity provider (IdP) metadata";
export const SBA_SAML_METADATA_REQUIRED_SP_DESCRIPTION = "The application requires SAML metadata configuration information from Imprivata.";
export const SBA_OIDC_METADATA_REQUIRED_SP_DESCRIPTION = "The application requires OpenID Connect metadata configuration information from Imprivata.";
export const SBA_WS_FED_METADATA_REQUIRED_SP_DESCRIPTION = "The application requires metadata configuration information from Imprivata.";
export const SBA_METADATA_REQUIRED_SP_DESCRIPTION = "The application requires SAML or OpenID Connect metadata configuration information from Imprivata.";
export const SBA_SAVE_BUTTON = "Save";

export const SBA_WARNING_BLANK_APPNAME = "Application name can't be blank";
export const SBA_WARNING_BLANK_USER_FRIENDLY_APPNAME = "Application user-friendly name can't be blank";
export const SBA_WARNING_BLANK_METADATA = "Application metadata can't be blank";
export const SBA_DEFAULT_NAME_ID_TITLE = "NameID format preference";
export const SBA_UNSPECIFIED_NAME_ID_ATTRIBUTE = "Returned attribute";

/* Download xml component*/
export const SBA_DOWNLOAD_XML_TITLE = "Download XML";
export const SBA_DOWNLOAD_XML_TEXT = "Download the Imprivata XML and upload it to the\n"
    + "configuration page of your SP.";

/* SBA Import*/
export const SBA_IMPORT_FROM_FILE_LABEL = "Get metadata from an XML file provided by the web application";
export const SBA_IMPORT_FILE_WARNING = "Metadata is not parsed";
export const SBA_IMPORT_FILE_BROWSE = "Browse...";
export const SBA_IMPORT_FROM_FILE = "From XML";
export const SBA_IMPORT_FROM_FILE_HINT = "Upload a valid xml for this application's metadata";
export const SBA_IMPORT_FROM_URL = "From URL";
export const SBA_IMPORT_FROM_URL_HINT = "Enter a valid URL for this application's metadata";
export const SBA_IMPORT_URL_CHOOSE_IMPORT = "Choose how to get SAML metadata for the web application:";
export const SBA_IMPORT_URL_IMPORT_URL = "Get metadata from the URL provided by the web application";
export const SBA_IMPORT_URL_WARNING = "Unable to connect to metadata URL. Check that the path is correct, check the network, or try again later.";

/*Metadata labels*/
export const SP_METADATA = "Service provider (SP) metadata";
export const SP_METADATA_PROVIDED_BY_URL = "Metadata provided by URL";
export const ACS_LABEL = "ACS Location";
export const ACS_INDEX = " Index: ";
export const ACS_DEFAULT = "(default)";
export const SLO_BINDING = "Binding: ";
export const SLO_RESPONSE = "Response: ";

/*Idp Metadata labels*/
export const IDP_METADATA_URL = "Metadata URL";
export const IDP_METADATA = "Imprivata IdP SAML Metadata";
export const OIDC_IDP_METADATA = "Imprivata IdP OpenID Connect Metadata";
export const WS_FED_IDP_METADATA = "Imprivata IdP WS-Federation metadata";
export const IDP_METHODS_TEXT_USE = "Use ";
export const IDP_METHODS_TEXT_ONE = "one";
export const IDP_METHODS_TEXT_END = " of the methods below, as indicated by the application.";
export const IDP_WS_FED_METADATA_SUBTITLE = "Copy these URLs and download the certificate to provide to the application.";
export const IDP_VIEW_AND_COPY_METADATA = "View and copy Imprivata (IdP) SAML metadata\t";
export const OIDC_IDP_VIEW_AND_COPY_METADATA = "View and copy Imprivata (IdP) OpenID Connect metadata\t";
export const WS_FED_IDP_VIEW_AND_COPY_METADATA = "View and copy your Imprivata WS-Federation IdP metadata\t";

export const IDP_METHOD_CERTIFICATE = "Imprivata IdP certificate";
export const IDP_METHOD_XML = "Metadata as an XML file";
export const IDP_COPY_SSO = "SSO";
export const IDP_COPY_SLO = "SLO";

/* SAML NameId format Titles*/
export const UNSPECIFIED = "Unspecified";
export const PERSISTENT = "Persistent";
export const TRANSIENT = "Transient";
export const EMAIL_ADDRESS = "Email address";
export const WINDOWS_DOMAIN_QUALIFIED_NAME = "Windows domain qualified name";

/* SAML NameId format Titles*/
export const UNSPECIFIED_NAME_ID_EMAIL_ADDRESS = "Email address (mail)";
export const UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME = "User logon name (userPrincipalName)";
export const UNSPECIFIED_NAME_ID_USER_DISPLAY_NAME = "User logon name - Pre W2K (sAMAccountName)";
export const UNSPECIFIED_NAME_ID_OBJECT_GUID = "User unique ID (UUID)";
export const UNSPECIFIED_NAME_ID_OBJECT_SID = "User security identifier (objectSID)";

/* User Attributes constants*/
export const USER_ATTRIBUTE_NAME = "User attribute name";
export const ATTRIBUTE_MAPPING = "Attribute mapping";
export const ATTRIBUTE_NAME = "Attribute name";

/* User Group Attributes constants*/
export const USER_GROUP_ATTRIBUTE_NAME = "Group attribute name";
export const USER_GROUP_ATTRIBUTE_FILTER = "Group name matching pattern";

/* User Attributes Titles*/
export const USER_ID = "User unique ID (UUID)";
export const OBJECT_SID = "User security identifier (objectSID)";
export const OBJECT_GUID = "User unique ID (objectGUID)";
export const FIRST_NAME = "First name (givenName)";
export const LAST_NAME = "Last name (surname)";
export const EMAIL = "Email address (mail)";
export const DOMAIN = "User domain";
export const USER_PRINCIPAL_NAME = "User logon name (userPrincipalName)";
export const USER_DISPLAY_NAME = "User logon name - Pre W2K (sAMAccountName)";
export const EPIC_USERNAME = "Epic username";
export const CUSTOM_ATTRIBUTE = "Static value:";
export const NET_BIOS_SAM_ACCOUNT_NAME = "User logon name - NetBIOS (NetBIOS Domain/sAMAccountName)";

/* User Group Attributes Titles*/
export const START_WITH = "starts with:";
export const CONTAIN = "contains:";
export const EQUALS = "is exactly:";

/* User Group Attributes Text*/
export const GROUP_NAME_MATCHING_PATTERN = "Enter at least 3 characters";


/* User Attributes Buttons*/
export const BUTTON_REMOVE_ATTRIBUTE = "Remove attribute";
export const BUTTON_ADD_ATTRIBUTE = "Add user attribute";
export const BUTTON_ADD_GROUP_ATTRIBUTE = "Add group attribute";

/* Customization page warnings*/
export const CUSTOMIZATION_IMAGE_WARNING = "The uploaded image file doesn't meet required specifications. Try another.";
export const CUSTOMIZATION_SAVED = "Changes saved";

/* Generic constants*/
export const VALUE = "Value";
export const OK = "OK";
export const CANCEL = "Cancel";
export const OR = "OR";
export const COPIED = "Copied";
export const COPY = "Copy";
export const DOWNLOAD = "Download";
export const DOCUMENTATION = "Documentation";

/*View Entry buttons*/
export const VIEW_ALL_METADATA = "View metadata";
export const REPLACE_METADATA = "Replace metadata";
export const GET_METADATA = "Get SAML metadata";

/* View All Metadata Pop-Up Titles */
export const ENTITY_ID = "Entity ID";
export const AUTH_REQUEST_SIGNED = "AuthRequestSigned";
export const ASSERTION_SIGNED = "AssertionSigned";
export const PUBLIC_SIGNED_KEY_CERTIFICATES = "Public Signing Key Certificates";
export const NO_CERTIFICATES = "No Certificates";
export const ENCRYPTION_KEY_CERTIFICATES = "Encryption Key Certificates";
export const NOT_SPECIFIED = "Not specified";
export const NAME_ID_FORMAT = "NameID Format";
export const ACS = "ACS";
export const SLO = "SLO";
export const VERSION = "Version: ";
export const SERIAL_NUMBER = "Serial Number: ";
export const SIGNATURE_ALGORITHM = "Signature Algorithm: ";
export const ISSUER = "Issuer: ";
export const VALID_NOT_BEFORE = "Valid Not Before: ";
export const VALID_NOT_AFTER = "Valid Not After: ";
export const SUBJECT = "Subject: ";
export const SUBJECT_PUBLIC_KEY_INFO = "Subject Public Key Info";
export const PUBLIC_KEY_ALGORITHM = "Public Key Algorithm: ";
export const PUBLIC_KEY = "Public Key:";
export const PUB = "pub:";
export const ISSUER_URL = "Issuer URL";
export const AUTHORIZE_ENDPOINT_URL = "Authorize endpoint URL";
export const TOKEN_ENDPOINT_URL = "Token endpoint URL";
export const USER_INFO_ENDPOINT_URL = "User info endpoint URL";
export const INTROSPECTION_ENDPOINT_URL = "Introspection endpoint URL";
export const LOGOUT_URL = "Logout URL";
export const WS_FED_ISSUER_URL = "Issuer URL";
export const WS_FED_PASSIVE_URL = "Passive URL";
export const WS_FED_ACTIVE_URL = "Active URL";
export const WS_FED_METADATA_URL = "Metadata URL";
export const WS_FED_LOGOFF_URL = "Logoff URL";

/* Non-white path scenario messages*/
export const APP_NAME_IS_DUPLICATED = " is already in use. Choose another name.";
export const UNABLE_TO_PARSE_METADATA_URL_OR_XML = 'Unable to parse metadata for this application. Provide another URL or XML file';
export const ATTRIBUTE_NAME_IS_DUPLICATED = " cannot be used for more than one attribute";
export const GENERIC_ERROR = 'A problem occurred. Try again or contact Imprivata Customer Support.';
export const GENERIC_ERROR_PART1 = 'A problem occurred. Try again or contact';
export const GENERIC_ERROR_SUPPORT_URL = 'http://support.imprivata.com/';
export const GENERIC_ERROR_PART2 = 'Imprivata Customer Support.';
/* Server response errors*/
export const SP_METADATA_URL_INVALID_IMPORT_URL = "Unable to connect to metadata URL. Check that the path is correct, check the network, or try again later.";

/* Customization page constants */
export const CUSTOMIZATION_TITLE = "Web App Login Configuration";
export const CUSTOMIZATION_SUBTITLE = "Configure appearance and behavior for all web application login screens";
export const CUSTOMIZATION_APPEARANCE_SECTION = "Appearance";
export const CUSTOMIZATION_APPEARANCE_DESCRIPTION = "Customize the background and logo to give your users the confidence to authenticate using their enterprise credentials.";
export const CUSTOMIZATION_BACKGROUND_COLOR = "Background color";
export const CUSTOMIZATION_ORGANIZATION_LOGO = "Organization logo";
export const UPLOAD = "Upload...";
export const CUSTOMIZATION_SESSION_SECURITY_SECTION = "Session security";
export const CUSTOMIZATION_SESSION_SECURITY_DESCRIPTION = "Customize security attributes for all users. Applies per browser instance.";
export const TERMINATION_SESSION_DROPDOWN_LABEL = "Log out user session after";

/* Azure AD */
export const AZURE_TITLE_ADD = "Add new Azure AD Integration";
export const AZURE_SUB_TITLE = "Azure Active Directory Tenant Information";
export const NICKNAME_PLACEHOLDER = "Nickname";
export const APPLICATION_NAME_PLACEHOLDER = "Directory ID";
export const ERROR_REQUIRED = "Required field. ";
export const ERROR_DIRECTORY_FORMAT = "Invalid directory ID format. ";
export const ERROR_DUPLICATE_DIRECTORY = "Duplicate Directory ID. ";
export const AZURE_DOCUMENTATION = "Microsoft Azure AD integration documentation";
export const SAVE_AND_GET_JSON = "Save and get JSON";
export const ADD_AZURE_SUCCESS = "Azure AD integration added.";
export const AZURE_TITLE_EDIT = "Edit Azure AD Integration";
export const MICROSOFT_AZURE_AD = "Microsoft Azure AD";
export const JSON = "JSON";
export const YOU_HAVE_NO_INTEGRATIONS = "You have no integrations";
export const LOADING_AZURE_AD_INTEGRATIONS = "Loading Azure AD integrations";

/* Confirm delete */
export const DELETE_INTEGRATION = "Delete integration?";
export const YES_DELETE = "Yes, Delete";
export const NO_DELETE = "No";

/* OIDC*/
export const OIDC_APPLICATION = "application using OpenID Connect";
export const OIDC_TITLE_ADD = "Add " + OIDC_APPLICATION;
export const OIDC_TITLE_EDIT = "Edit " + OIDC_APPLICATION;
export const OIDC_SUBTITLE = "Configure an OpenID Connect-based application for single sign-on.";
export const OIDC_URIS_TITLE = "Redirect URIs";
export const OIDC_URIS_SUBTITLE = "To redirect users to a given application, provide at least one URI.";
export const OIDC_ADD_URI = "Add URI";
export const OIDC_REMOVE_URI = "Remove URI";
export const OIDC_URI_PLACEHOLDER = "Enter your redirect URI here";
export const OIDC_URI_IS_DUPLICATED = "One or more duplicate redirect URIs.";
export const OIDC_CLIENT_CREDENTIALS = "Client credentials";
export const OIDC_CLIENT_ID = "Client ID";
export const OIDC_CLIENT_SECRET = "Client secret";
export const OIDC_DONE = "Done";
export const OIDC_GENERATE_CLIENT_CREDENTIALS = "Generate client credentials";
export const OIDC_GENERATE_NEW_CLIENT_SECRET = "Generate new client secret";
export const OIDC_CLIENT_SECRET_BODY_ROW_ONE_TEXT_ONE = "Generating a new client secret will ";
export const OIDC_CLIENT_SECRET_BODY_ROW_ONE_TEXT_TWO = "immediately ";
export const OIDC_CLIENT_SECRET_BODY_ROW_ONE_TEXT_THREE = "invalidate the current client secret.";
export const OIDC_CLIENT_SECRET_BODY_ROW_TWO_TEXT_ONE = "You must ";
export const OIDC_CLIENT_SECRET_BODY_ROW_TWO_TEXT_TWO = "update the client secret in the OIDC client (relying party) ";
export const OIDC_CLIENT_SECRET_BODY_ROW_TWO_TEXT_THREE = "app configuration to maintain single sign-on functionality.";
export const OIDC_PUBLIC_CLIENT_LABEL = 'Public client';
export const OIDC_PUBLIC_CLIENT_INFO = 'Public clients are less secure. Use with caution.';

/* OIDC EntraId EAM */
export const OIDC_ENTRA_ID_EAM_APPLICATION = "Entra ID integration";
export const OIDC_ENTRA_ID_EAM_TITLE_ADD = "Add " + OIDC_ENTRA_ID_EAM_APPLICATION;
export const OIDC_ENTRA_ID_EAM_TITLE_EDIT = "Edit " + OIDC_ENTRA_ID_EAM_APPLICATION;
export const OIDC_URI_TITLE = "Redirect URI";
export const OIDC_URI_SUBTITLE = "To redirect users to a given application, provide URI.";
export const ENTRA_ID_TENANT_ID = "Entra Tenant ID";
export const REDIRECT_TO_WORKFLOW_POLICY_PAGE_LABEL = "Configure Second-factor only workflow on";
export const WORKFLOW_POLICY_PAGE = "Workflow policy page";

/* Certificate expiration banners*/
export const SP_CERTIFICATE_EXPIRES = "SP certificate expires on expirationDate. ";
export const SP_CERTIFICATE_EXPIRED = "SP certificate expired on expirationDate. ";
export const REPLACE_METADATA_TO_UPDATE_CERTIFICATE = " to update the certificate.";
export const SP_METADATA_UPDATED = "SP metadata updated. New SP certificate valid until expirationDate.";
export const IDP_CERTIFICATE_EXPIRES = "IdP certificate expires on expirationDate. New certificate available in Imprivata IdP metadata below. ";
export const IDP_METADATA_UPDATED = "IdP metadata updated. New IdP certificate valid until expirationDate.";
export const LEARN_MORE = "Learn more";

/* Idp certificate rotation */
export const NEW_IDP_CERTIFICATE_PANEL_HEADER = "New IdP certificate available in updated metadata";
export const RECONFIGURE_SBA_WITH_UPDATED_IDP_METADATA = "Reconfigure the web application with the updated Imprivata IdP metadata:";
export const NEW_SAML_IDP_METADATA_VIEW_AND_COPY_BUTTON = "View and copy your Imprivata enterprise (IdP) SAML metadata";
export const NEW_WS_FED_IDP_METADATA_VIEW_AND_COPY_BUTTON = "View and copy your Imprivata enterprise (IdP) WS-Federation metadata";
export const START_USING_NEW_IDP_CERTIFICATE_TITLE = "As web application is updated, simultaneously start using the new IdP certificate:";
export const START_USING_NEW_IDP_CERTIFICATE_BUTTON = "Start using new IdP certificate";
export const START_USING_NEW_IDP_CERTIFICATE_MODAL_HEADER = "Start using new IdP certificate";
export const START_USING_NEW_IDP_CERTIFICATE_MODAL_BODY_SECTION_1 = "Imprivata can now use the new IdP certificate for assertions with this web application.";
export const START_USING_NEW_IDP_CERTIFICATE_MODAL_BODY_SECTION_2 = "If the web application's metadata has not been reconfigured yet, click Close, and start using new IdP certificate when the reconfiguration occurs.";
export const USE_NEW_CERTIFICATE_BUTTON = "Use new certificate";
export const CLOSE_BUTTON = "Close";

/* WS-Federation */
export const WS_FED_APPLICATION = "application using WS-Federation";
export const WS_FED_TITLE_ADD = "Add " + WS_FED_APPLICATION;
export const WS_FED_TITLE_EDIT = "Edit " + WS_FED_APPLICATION;
export const WS_FED_SUBTITLE = "Configure a WS-Federation (WS-Trust) based application for single sign-on.";
export const WS_FED_URI_TITLE = "Redirect URI";
export const WS_FED_URI_SUBTITLE = "Provide the URI to redirect users to a given application.";
export const WS_FED_URI_PLACEHOLDER = "Enter your redirect URI here";
export const WS_FED_GENERATE_METADATA = "Generate Imprivata WS-Federation IdP metadata";

/* Oidc custom claims constants */
export const CLAIMS_TITLE = "Claims";
export const SCOPE = " scope";
export const CLAIM_NAME = "Claim name";
export const CLAIM_ATTRIBUTE_MAPPING = "Attribute mapping";
export const ID_TOKEN = "ID Token";
export const ACCESS_TOKEN = "Access Token";
export const BUTTON_ADD_CLAIM = "Add claim";
export const BUTTON_REMOVE_CLAIM = "Remove";
export const BUTTON_ADD_CUSTOM_SCOPE = "Add custom scope";
export const BUTTON_REMOVE_SCOPE = "Remove";
export const CUSTOM_SCOPE = "Custom scope";
export const SCOPE_NAME_IS_EMPTY = "Scope name cannot be empty. Either delete scope or provide a name";
export const SCOPE_NAME_IS_DUPLICATED = " cannot be used for more than one scope";
export const CLAIM_NAME_IS_DUPLICATED = " cannot be used for more than one claim";

/* OIDC Configurable Workflow constants */
export const DEFAULT_ACTION= "Default";
export const ACR_MAPPING_TITLE= "Workflow";
export const ACR_MAPPING_SUBTITLE= "Authentication Context Class Reference is an OIDC authentication strength claim";
export const BUTTON_REMOVE_ACR = "Remove";
export const ACR_VALUE_PLACEHOLDER = "Enter ACR value";
export const ACR_VALUE_COLUMN = "ACR value";
export const WORKFLOW_COLUMN = "Workflow";
export const ACTIONS_COLUMN = "";
export const ADD_BUTTON = "Add";
export const EPCS_WORKFLOW_CANNOT_ASSIGNED_TO_PUBLIC_CLIENT = "For the EPCS workflow public client cannot be selected.";
export const ACR_VALUE_IS_DUPLICATED = " cannot be used for more than one ACR value";
export const ACR_VALUE_IS_EMPTY = "ACR value cannot be empty.";
export const OIDC_WARNING_BLANK_ENTRA_ID_TENANT_ID = "Entra Tenant ID can't be blank";

/* Key length customization */
export const METADATA_HEADER = "Metadata";
export const CERTIFICATE_KEY_HEADER = "Certificate key length";
export const KEY_LENGTH_2048 = "2048 bits";
export const KEY_LENGTH_4096 = "4096 bits";
export const KEY_LENGTH_MODAL_HEADER = "Update key length";
export const KEY_LENGTH_MODAL_BODY_SECTION_2048 = "This action will update the WebSSO certificate to 2048 bit key length.";
export const KEY_LENGTH_MODAL_BODY_SECTION_4096 = "This action will update the WebSSO certificate to 4096 bit key length.";
export const KEY_LENGTH_MODAL_CONFIRM_BUTTON_2048 = "Use 2048 key length";
export const KEY_LENGTH_MODAL_CONFIRM_BUTTON_4096 = "Use 4096 key length";
